import React, { Component } from 'react';
import { BasicInfoType } from '../../redux/auth/authTypes';

type AppProps = {
  basicInfo?: BasicInfoType
}

const BasicInfo = ({ basicInfo }: AppProps) => {
  const name = `${ basicInfo?.first_name } ${ basicInfo?.last_name }`;
  const email = basicInfo?.email;
  const jobTitle = basicInfo?.job_title;
  const birthday = basicInfo?.birthday === "undefined" ? "" : basicInfo?.birthday;
  const userName = basicInfo?.user_name


  return (
    <div className="w-75">
      <div className="form-group row">
        <div className="float-label">
          <label htmlFor="name"
            className={name ? "active" : ""}
          >Name</label>
          <input
            type="name"
            className="form-control"
            name="name"
            value={name}
            required
            autoComplete="name"
            autoFocus
            disabled
            onChange={() => { }}
          />
        </div>
      </div>
      <div className="form-group row">
        <div className="float-label">
          <label htmlFor="name"
            className={email ? "active" : ""}
          >Email</label>
          <input
            type="email"
            className="form-control"
            name="email"
            value={email}
            required
            autoComplete="email"
            autoFocus
            disabled
            onChange={() => { }}
          />
        </div>
      </div>
      <div className="form-group row">
        <div className="float-label">
          <label htmlFor="name"
            className={jobTitle ? "active" : ""}
          >Job Title</label>
          <input
            type="email"
            className="form-control"
            name="email"
            value={jobTitle}
            required
            autoComplete="job-title"
            autoFocus
            disabled
            onChange={() => { }}
          />
        </div>
      </div>
      <div className="form-group row">
        {/* <div className="float-label">
          <label htmlFor="name"
            className={startDate ? "active" : ""}
          >Start Date</label>
          <input
            type="email"
            className="form-control"
            name="email"
            value={startDate}
            required
            autoComplete="job-title"
            autoFocus
            disabled
            onChange={() => { }}
          />
        </div> */}
      </div>
      <div className="form-group row">
        <div className="float-label">
          <label htmlFor="name"
            className={birthday ? "active" : ""}
          >Birthday</label>
          <input
            type="email"
            className="form-control"
            name="email"
            value={birthday}
            required
            autoComplete="job-title"
            autoFocus
            disabled
            onChange={() => { }}
          />
        </div>
      </div>
      <div className="form-group row">
        {/* <div className="float-label">
          <label htmlFor="name"
            className={userBranch ? "active" : ""}
          >User Branch</label>
          <input
            type="email"
            className="form-control"
            name="email"
            value={userBranch}
            required
            autoComplete="job-title"
            autoFocus
            disabled
            onChange={() => { }}
          />
        </div> */}
      </div>
      {basicInfo?.user_name && <div className="form-group row">
        <div className="float-label">
          <label htmlFor="name"
            className={userName ? "active" : ""}
          >User Name</label>
          <input
            type="email"
            className="form-control"
            name="email"
            value={userName}
            required
            autoComplete="job-title"
            autoFocus
            disabled
            onChange={() => { }}
          />
        </div>
      </div>}
    </div>
  )
}

export default BasicInfo;